import ApiService from "./api.service";
export default class PromotionUsageService extends ApiService {
    static base_url = `${super.base_url}/promotions_usages`;
}
